define([
	"dojo/_base/declare",
	"underscore"
], function(declare) {

	return declare(null, {
		// Boolean: indicates if report row can be calculated based on group results
		supportsGroups: true,
		
		// Object: set of attributes used internally to calculate report 
		_internalAttributes: {
			//AttributeId: 1
		},
		
		contains: function(/*Spec*/spec) {
			// summary: return true if spec processed by report
			var qs = spec.querySpec;
			return qs && qs.id && !this._internalAttributes[qs.id];
		},
		
		/**
		 * Extension point to write operations to calculate report for given query result
		 * @param {QueryResult} qr 
		 * @param {Writer} writer
		 * @return {Function} - callback function to call when server request is complete
		 */
		generate: function(qr, writer) {
			console.assert(false);
			return null;
		},
		
		/**
		 * Return store which contains nodes to be reported on; make sure to handle given QueryResult 
		 * can either represent a report row or a group row (which also acts as a report row)
		 * @param {QueryResult} qr 
		 */
		_getReportStore: function(qr) {
			if (!qr.bResultNode) {
				qr = qr.parentResult;
			}

			return qr.getStore();
		}	
	});
});